module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/sample-count-released.jpg?v=10859984";